module.exports = __webpack_public_path__ + "img/rightSwitch.ce9892a7.png";